module.exports = __webpack_public_path__ + "static/media/cashbackMarketplace.4a6be2d6.png";